import script from "./RoutingAddressesList.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoutingAddressesList.vue?vue&type=script&setup=true&lang=ts"

import "./RoutingAddressesList.vue?vue&type=style&index=0&id=11830160&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11830160"]])

export default __exports__